import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ShowLeavingDialogCommand {
  continueCallback: () => void;
}

export const showLeavingDialog: GraphCommandFactory<ShowLeavingDialogCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.leavingDialog.open = true;
      draft.leavingDialog.continueCallback = command.continueCallback;
    });
  };
